import React from 'react';

function About() {
  return (
    <section id="about" className="about">
      <h2>Your Success is Our Technology</h2>
      <p className="about-intro">
        We bridge the gap between business challenges and practical technology, helping your team remove friction, reduce risk, and move faster.
      </p>

      <div className="about-grid">
        <article className="about-card">
          <h3>Our Mission</h3>
          <p>
            We do not just write code or move data to the cloud. We partner with you to solve the specific operational problems that slow delivery, increase cost, or hold revenue back.
          </p>
        </article>

        <article className="about-card">
          <h3>Our Vision</h3>
          <p>
            Our vision is a future where technology is invisible, intuitive, and empowers your people to do their best work, freeing them from repetitive tasks and helping them focus on what matters.
          </p>
        </article>

        <article className="about-card">
          <h3>Our Core Values</h3>
          <ul>
            <li><strong>Transparent Partnership:</strong> No hidden fees, no over-promising, and clear guidance about what is possible.</li>
            <li><strong>Future-Proof Solutions:</strong> We use modern technology only when it directly solves your problem.</li>
            <li><strong>Your Team, Extended:</strong> We work with your staff, share knowledge, and avoid creating dependency.</li>
            <li><strong>Quality You Can Measure:</strong> We define success through outcomes like cost savings, faster delivery, and better customer experience.</li>
          </ul>
        </article>
      </div>
    </section>
  );
}

export default About;
